import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import PagedView from 'Shared/components/PagedView/PagedView';
import {getEmployerEnrollmentDetails, changeEnrollmentDetailsFilters} from 'Enrollment/ducks/employerEnrollment';
import * as qs from 'query-string';
import {useLocation} from 'react-router-dom';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {EnrollmentRouteConstants} from 'Enrollment/Routes';
import CardField from 'Shared/components/CardField';
import ModularHost from 'Shared/components/ModularHost/ModularHost';
import ToolbarHeader, {ExportToolbarHeaderIconWithCustomError} from 'Shared/components/Toolbar/ToolbarHeader';
import {FileExtension} from 'Shared/components/FileDownloadButton';
import {withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import agencyFilterSelector from 'Users/selectors/selectAgencyFilters';
import * as O from 'fp-ts/lib/Option'
import {isLoaded} from 'Core/models/Async';

const EmployerDiscrepantEnrollmentsDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {employerEnrollmentDetailPage, enrollmentFileDetailsFilter} = useSelector(
    (state: ReducerState) => state.employerEnrollment
  );

  const discrepantStatus = qs.parse(location.search).discrepantStatus as number | undefined;

  const changeFilter = withValueChangedHook(enrollmentFileDetailsFilter, changeEnrollmentDetailsFilters, dispatch);
  const agencyFilters = useSelector(agencyFilterSelector);
  const filterProperties = {
    changeFilter,
    filterData: enrollmentFileDetailsFilter,
  };
  const [isLoad, setLoad] = useState(true);

  useBreadcrumbs(
    'Unsuccessful Processing',
    EnrollmentRouteConstants.EMPLOYER_ENROLLMENTS_DISCREPANT_DETAILS(discrepantStatus)
  );

  const getTitle = (status: string | undefined) => {
    switch (status) {
      case "0":
        return 'Unsuccessful';
      case "1":
        return 'Outstanding Unsuccessful';
      case "2":
        return 'In Progress';
      case "3":
        return 'Successful';
    }
  };

  useEffect(() => {
    debugger;
    if (discrepantStatus) {
      enrollmentFileDetailsFilter.accountNumber = '';
      enrollmentFileDetailsFilter.discrepantStatusId = discrepantStatus!.toString();
      let agentData = O.toUndefined(agencyFilters);
      enrollmentFileDetailsFilter.isNewYork = agentData?.isNewYork;
      enrollmentFileDetailsFilter.agentNumbers = agentData?.agentNumbers.join();
      enrollmentFileDetailsFilter.encryptedIdentifier = agentData?.encryptedIdentifier;
      if (isLoad) {
        clearFilterFields();
        setLoad(false);
      }
    }

    dispatch(getEmployerEnrollmentDetails(undefined, enrollmentFileDetailsFilter));
  }, [dispatch, enrollmentFileDetailsFilter]);

  const clearFilterFields = () => {
    enrollmentFileDetailsFilter.ssn = '';
    enrollmentFileDetailsFilter.requestType = '';
    enrollmentFileDetailsFilter.fileName = '';
    enrollmentFileDetailsFilter.product = '';
    enrollmentFileDetailsFilter.firstName = '';
    enrollmentFileDetailsFilter.lastName = '';
  };

  return (
    <>
      <ModularHost>
        <ToolbarHeader title= {getTitle(discrepantStatus?.toString()) + " Details"}>
          
        </ToolbarHeader>
        <PagedView
          pagedViewKey="employerEnrollmentReportDetails"
          data={employerEnrollmentDetailPage}
          loadMore={page => dispatch(getEmployerEnrollmentDetails(page, enrollmentFileDetailsFilter))}
        >
          {columnProps => (
            <>
              <Column
                {...columnProps}
                title="Request Type"
                filterProperties={withStringFilterProperties(filterProperties, 'requestType')}
                default
              >
                {enrollmentFile => enrollmentFile.requestType}
              </Column>
              <Column
                {...columnProps}
                title="File Name"
                filterProperties={withStringFilterProperties(filterProperties, 'fileName')}
              >
                {enrollmentFile => enrollmentFile.fileName}
              </Column>
              <Column
                {...columnProps}
                title="Account Number"
                filterProperties={withStringFilterProperties(filterProperties, 'accountNumber')}
                default
              >
                {enrollmentFile => enrollmentFile.accountNumber}
              </Column>
              <Column
                {...columnProps}
                title="SSN"
                filterProperties={withStringFilterProperties(filterProperties, 'ssn')}
                default
              >
                {enrollmentFile => enrollmentFile.ssn}
              </Column>
              <Column
                {...columnProps}
                title="Product"
                filterProperties={withStringFilterProperties(filterProperties, 'product')}
                default
              >
                {enrollmentFile => enrollmentFile.product}
              </Column>
              <Column
                {...columnProps}
                title="First Name"
                filterProperties={withStringFilterProperties(filterProperties, 'firstName')}
                default
              >
                {enrollmentFile => enrollmentFile.firstName}
              </Column>
              <Column
                {...columnProps}
                title="Last Name"
                filterProperties={withStringFilterProperties(filterProperties, 'lastName')}
                default
              >
                {enrollmentFile => enrollmentFile.lastName}
              </Column>
              <Column {...columnProps} title="Attempts" default>
                {enrollmentFile => enrollmentFile.attempts}
              </Column>
              <Column {...columnProps} title="Unsuccessful Age" default>
                {enrollmentFile => enrollmentFile.ageOfUnsuccessfullInDays}
              </Column>
            </>
          )}
        </PagedView>
      </ModularHost>
    </>
  );
};

export default EmployerDiscrepantEnrollmentsDetails;
